import { Directive, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[disable-click]'
})
export class DisableClickDirective {

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    $(this.el.nativeElement).click(function (event) { event.stopPropagation(); });
  }

}
